import { ArrayUtils, engineComponent, NumberUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { BetManager } from "../Managers/BetManager";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";
import { Languages } from "../Utils/Languages";
import { LayoutSwitchElement } from "./LayoutSwitchElement";

@engineComponent(ComponentTypes.DisplayObject)
export class BonusCounters extends LayoutSwitchElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private counters: Array<SwitchElement>;

    private multipliers: Array<number>;

    //******************************************************************************************************************
    //  FUNCTIONS
    //******************************************************************************************************************

    public createByNode(node: Element): void {
        super.createByNode(node);

        if (node.hasAttribute(BonusCountersAttributes.MULTIPLIERS)) {
            this.multipliers = ArrayUtils.numberArray(node.getAttribute(BonusCountersAttributes.MULTIPLIERS));
        }

        this.counters = [];
        if (this.elements.childs["Mini"] != null) {
            this.counters.push(this.elements.childs["Mini"]);
        }

        if (this.elements.childs["Minor"] != null) {
            this.counters.push(this.elements.childs["Minor"]);
        }

        if (this.elements.childs["Major"] != null) {
            this.counters.push(this.elements.childs["Major"]);
        }

        if (this.elements.childs["Grand"] != null) {
            this.counters.push(this.elements.childs["Grand"]);
        }
    }

    public updateByNode(node: Element): void {
        super.updateByNode(node);
    }

    public updateCounters(): void {
        if (this.counters != null && this.multipliers != null && BetManager.Bet) {
            for (let i = 0; i < this.counters.length; i++) {
                const value = NumberUtils.multiply(this.multipliers[i], BetManager.Bet);
                this.updateLevelValue(this.counters[i], value);
            }

            // this.updateGrandCountToPosition();
        }
    }

    private updateLevelValue(level: SwitchElement, value: string): void {
        if (level != null) {
            this.setAmount(<ImageTextElement>level.getChildElementByName("Amount"), value, true);
            this.setAmount(<ImageTextElement>level.getChildElementByName("AmountGlow"), value, true);
        }
    }

    private setAmount(textElement: ImageTextElement, value: string, format?: boolean): void {
        if (textElement != null) {
            textElement.bitmapText.text = format ? Languages.formatText(Languages.FormatMoney, value) : value;
            textElement.realign();
        }
    }

    public counterGoToCase(counterIndex: number, caseType: string): void {
        if (this.counters[counterIndex] != null) {
            if (!this.allowCounterGoToCase(counterIndex, this.counters[counterIndex].getCurrentCase(), caseType)) {
                return;
            }

            this.counters[counterIndex].goToCase(caseType);
        }
    }

    public allCounterGoToCase(caseType: string): void {
        for (let i = 0; i < this.counters.length; i++) {
            if (this.counters[i] != null) {
                this.counters[i].goToCase(caseType);
            }
        }
    }

    private allowCounterGoToCase(counterIndex: number, currentCase: string, nextCase: string): boolean {
        if (currentCase == nextCase) {
            return false;
        }

        if (counterIndex == 3) {
            if (currentCase == "TEASE_POPPING" && nextCase == "TEASE_POP") {
                return false;
            }
        }
        return true;
    }

    private updateGrandCountToPosition(): void {
        const grandLevel = this.counters[this.counters.length - 1];

        if (grandLevel != null) {
            const textElement = <ImageTextElement>grandLevel.getChildElementByName("Amount");
            const counterElement = <SwitchElement>grandLevel.getChildElementByName("CounterTo");

            counterElement.x = textElement.x + textElement.bitmapText.x;
        }
    }

    public updateGrandCountToValue(value: string, caseType: string): void {
        const grandLevel = this.counters[this.counters.length - 1];

        if (grandLevel != null) {
            const counterElement = <SwitchElement>grandLevel.getChildElementByName("CounterTo");
            if (counterElement != null) {
                const textElement = <SwitchElement>counterElement.getChildElementByName("Amount");

                if (textElement != null) {
                    textElement.goToCase(value);
                }

                counterElement.goToCase(caseType);
            }
        }
    }
}

export const BonusCountersAttributes = {
    MULTIPLIERS: "Multipliers",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/BonusCounters.ts
 **/